import 'core-js/stable';
import 'regenerator-runtime/runtime';
import React from 'react';
import {render} from 'react-dom';
import cloudinary from 'cloudinary-core';
import APIUtils from '@spothero/utils/api';
import Config from 'config';
import Navigation from 'header/Navigation';
import Footer from 'footer/Footer';

window.SHInitNavAndFooter = ({
    navContainer,
    footerContainer,
    isProduction,
    user
}) => {
    Config.set({
        spotHeroAPIUrl: process.env.SPOTHERO_API_URL,
        staticFilesDomain: process.env.STATIC_FILES_DOMAIN,
        siteUrl: process.env.SITE_URL,
        serviceAPIUrl: `https://services.${(process.env.IS_PRODUCTION) ? 'production' : 'staging'}.spothero.com`,
        isDeployed: (process.env.IS_DEPLOYED) ? JSON.parse(process.env.IS_DEPLOYED) : false,
        isProduction: (process.env.IS_PRODUCTION) ? JSON.parse(process.env.IS_PRODUCTION) : false,
        cloudinary: cloudinary.Cloudinary.new({
            cloud_name: 'spothero' // eslint-disable-line camelcase
        })
    });
    APIUtils.init({
        baseUrl: Config.spotHeroAPIUrl,
        xsrfCookieName: 'csrftoken',
        xsrfHeaderName: 'X-CSRFToken',
        additionalHeaders: {
            Authorization: null,
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    });

    if (navContainer) {
        render(
            <Navigation
                isProduction={isProduction}
                user={user}
                isMonolith
            />,
            navContainer
        );
    }

    if (footerContainer) {
        render(
            <Footer
                email={user.email}
                isMonolith
            />,
            footerContainer
        );
    }
};
